import { Component, Input } from '@angular/core';
import { LabelMaps, Ranking, Venue } from 'globals/store/events.data';
import { OnsiteSingleTimeline } from 'globals/store/onsite.data';
import { Performer } from 'globals/store/performers.data';
import { Sponsor } from 'globals/store/sponsors.data';
import { Exhibitor } from 'globals/store/exhibitors.data';
import { JoiResource } from 'globals/store/resources.data';
import { Dictionary } from '@ngrx/entity';
import { Attendee } from 'globals/store/attendees.data';
import { OnsiteSingleTimelineComponent } from 'src/app/modules/onsiteschedule/onsite.singletimeline.component';
import { AddToCalComponent } from '../misc/add-to-cal.component';
import { SharedTimelineComponent } from '../wrappers/shared-timeline-wrapper.component';
import { ExpandingWrapperComponent } from '../wrappers/expanding-wrapper.component';
import { CommonModule } from '@angular/common';
import { CustomDatePipe } from 'src/app/services/pipes/customDatePipe.pipe';

@Component({
    selector: 'brief-timeline',
    templateUrl: './briefTimeline.html',
    styleUrls: ['./briefView.scss'],
    standalone: true,
    imports: [OnsiteSingleTimelineComponent, AddToCalComponent, SharedTimelineComponent, ExpandingWrapperComponent, CommonModule, CustomDatePipe]
})
export class BriefTimelineComponent { // extracted so can also be shown in resource => logistics

  @Input() performers: { [pId: string]: Performer }
  @Input() sponsors: { [key: string]: Sponsor }
  @Input() sponsorTypes: { [tId:string]: Ranking }
  @Input() performer:Performer
  @Input() exhibitor: Exhibitor
  @Input() resource: JoiResource
  @Input() attendee: Attendee
  @Input() eventTitle: string
  @Input() eventId: string
  @Input() labelMaps: LabelMaps
  @Input() publicView: boolean;
  @Input() venues: { [vId:string]: Venue }
  @Input() unavailable = false
  @Input() showActivityStatus = true
  @Input() timeline: OnsiteSingleTimeline[]
  @Input() shareCode: string
  @Input() standalone: boolean
  @Input() performerRoles: Dictionary<Ranking>
  initialized = false
  
  trackByDate(index, item: OnsiteSingleTimeline) {
    return item.date.toString()
  }
  
  getTypeOf(o) {
    return typeof o
  }


}

